import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PerfilService } from '../../../shared/services/apis/usuario-admin/perfil.service';
import { ListaPerfilResponse } from '../../../shared/services/responses/usuario-admin/lista-perfil.response';
import { PerfilEnum } from '../../../shared/enums/perfil.enum';
import { ListaPerfilStruct } from '../../../shared/services/structs/usuario-admin/lista-perfil.struct';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-perfil-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    TemPermissaoDirective,
  ],
  templateUrl: './perfil-lista.component.html',
  styleUrl: './perfil-lista.component.css',
})
export class PerfilListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private perfilService: PerfilService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Master;
    this.funcionalidadeEnum = FuncionalidadeEnum.Master_Perfil;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaPerfilResponse: ListaPerfilResponse | undefined;
  public displayedColumns: string[] = ['idPerfil', 'nomePerfil', 'descricao', 'action-edit', 'action-delete'];
  public _dataSource = new MatTableDataSource<ListaPerfilStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
    });

    this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const pesquisa: string = this.model.get('pesquisa')?.value;

    this.perfilService.get(pesquisa, this._paginaAtual).subscribe({
      next: (response: ListaPerfilResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaPerfilResponse) {
          this._listaPerfilResponse = response;
          this._ultimaPagina = false;
        } else if (response.listaPerfil?.length > 0) {
          this._listaPerfilResponse.listaPerfil.push(...response.listaPerfil);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaPerfilResponse.listaPerfil;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaPerfilResponse = undefined;
    this.pesquisar();
  }

  abrirModalExcluir(idPerfil: number, nomePerfil: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir o perfil ${nomePerfil}? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.excluir(idPerfil);
        }
      },
    });
  }

  private excluir(idPerfil: number): void {
    this.perfilService.excluir(idPerfil).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Perfil excluido com sucesso', AlertType.success);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  disableDelete(idPerfil: number): boolean {
    if (idPerfil === PerfilEnum.Todos) {
      return true;
    } else return false;
  }
}
